import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import characters from './reducers/characters';
import drawStage from './reducers/draw-stage';
import doodleStage from './reducers/doodle-stage';
import logger from 'redux-logger';
const MaybeLogger = process.env.REACT_APP_BUILD_ENV !== 'production' && logger;
const middleware = MaybeLogger ? [thunk, logger] : [thunk];

const globalReducer = combineReducers({
  characters,
  drawStage,
  doodleStage,
});
const Store = createStore(globalReducer, applyMiddleware(...middleware));

export default Store;
